module.exports = __webpack_public_path__ + "img/background014.jpg";